module.exports = __webpack_public_path__ + "img/mikmic_store_image.23c6e1bd.png";